import { isVNode } from './utils';
import alert from './template/alert';
import confirm from './template/confirm';
import notify from './template/notify';

var frames = {}

export var framesInit = box => {
    let data = {}

    for (const key in frames) {
        const fn = frames[key];
        data[key] = fn(box)
    }

    return data
}

export var expandFrame = obj => {
    frames = {
        ...frames,
        ...obj
    }
}

expandFrame({
    alert,
    confirm,
    notify
})